import Campus from './sub-components/Campus';
import DateTest from './sub-components/DateTest';
import Formation from './sub-components/Formation';
import Amenagement from './Amenagement';
import { Col, Row } from 'reactstrap';
import TagManager from 'react-gtm-module';


const tagManagerArgs = {
    dataLayer: {
        'event': 'eni_JourneeInscription'
    },
    dataLayerName: 'PageDataLayer'
}

const Journee = ({ nextStep, handleChange, values, modalites, campus, filieres, typesFormations, handleErreur, CodeTypeJourneeInformation }) => {
    
    const dates = filieres?.find(f => (f.id == values.idFiliere && CodeTypeJourneeInformation == 0)/*Cas journée test classique*/ || (f.id === 3 && CodeTypeJourneeInformation == 1)/*Cas journée école*/)
        ?.formations?.find(f => (f.id == values.idFormation && CodeTypeJourneeInformation == 0)/*Cas journée test classique*/ || (f.id === 1400949 && CodeTypeJourneeInformation == 1)/*Cas journée école*/)
        ?.journeesTest;

    const getModalite = () => {
        return modalites.map((modalite) => {
            return <option key={modalite.id} value={modalite.id}>{modalite.libelle}
            </option>;
        });
    }
    const getTypeFormation = () => {
        return typesFormations
            .filter((typeFormation) => {
                return (
                    values.idModaliteSuivi == 121581 /*Présentiel*/ &&
                    values.idCampus == 16 && /*Nantes*/
                    values.idFormation == process.env.REACT_APP_ID_TECHNICIEN_HELPDESK/*formation Technicien HelpDesk*/ &&
                    typeFormation.id == 121134 /*Formation continue*/
                )
                    ||
                    (values.idFormation != process.env.REACT_APP_ID_TECHNICIEN_HELPDESK)
            })
            .map((typesFormation) => {
                return <option value={typesFormation.id}>{typesFormation.libelle}
                </option>;
            });
    }
    const getFiliere = () => {
        const buttons = [];

        // Ajouter les boutons dynamiques
        filieres.forEach((filiere) => {
            if (filiere.libelle && filiere.id != 3) {
                var checked = filiere.id == values.idFiliere ? "checked" : "";
                buttons.push(
                    <div key={filiere.id} className="form-check-inline d-flex">
                        <input
                            type="radio"
                            checked={checked}
                            name="filiere"
                            id={'filiere' + filiere.id}
                            value={filiere.id}
                            onChange={handleChange('idFiliere')}
                        />
                        <label className="openSans fs-16 lh-15" htmlFor={'filiere' + filiere.id}>
                            {filiere.libelle}
                        </label>
                    </div>
                );
            }
        });

        // Ajout du bouton cycle ingénieur qui fait un traitement à part
            /*
                Les filières représentent la famille de formation :
                    Réseau = 1
                    Développement = 2

                Elles sont utilisées pour les choix via des boutons radio.
                Pour gérer le troisième bouton radio, lié au Cycle Ingénieur, 
                j’ai décidé arbitrairement de lui attribuer la value 20, car il fait l’objet d’un traitement à part.
            */ 
        buttons.push(
            <div key="static-filiere" className="form-check-inline d-flex">
                <input
                    type="radio"
                    checked={values.idFiliere == 20 ? "checked" : ""}
                    name="filiere"
                    id="filiere-cycle-ingenieur"
                    value={20}
                    onChange={handleChange('idFiliere')} 
                />
                <label className="openSans fs-16 lh-15" htmlFor="filiere-cycle-ingenieur">
                    Cycle ingénieur
                </label>
            </div>
        );

        return buttons;
    }
    const Continue = e => {
        e.preventDefault();
        nextStep();
    }

    TagManager.dataLayer(tagManagerArgs)

    return (
        <div>
            <h1 className="mb-5 color-magenta-eni spinnaker text-center fs-32 fw-bold">{CodeTypeJourneeInformation == 1 ? "Vous venez de suivre une présentation dans votre établissement et vous souhaitez passer les tests ? Inscrivez-vous dès maintenant."
                : "Sélectionnez votre souhait de formation"}</h1>
            <Amenagement/>
            <Row className="mb-5 mt-5">
                <Col sm="6">
                    <div class="d-flex flex-column">
                        <label className="mb-2">Comment souhaitez-vous réaliser la formation ?*</label>
                        <select
                            type="text"
                            value={values.idModaliteSuivi}
                            onChange={handleChange('idModaliteSuivi')}
                            id="idModaliteSuivi"
                        >
                            <option value="0" selected="selected"></option>
                            {getModalite()}
                        </select>
                        {handleErreur('idModaliteSuivi')}
                    </div>
                </Col>
                <Col sm="6">
                    {(values.idModaliteSuivi == "121581")/*Présentiel*/ &&
                        <Campus
                            values={values}
                            campus={campus}
                            handleChange={handleChange}
                            handleErreur={handleErreur} />
                    }
                </Col>
            </Row>
            <Row className="mb-5">
                <Col sm="6">
                    <div class="d-flex flex-column">
                        <label className="mb-2">Quelle filière vous intéresse ?*</label>
                        <div class="d-flex flex-column flex-md-row gap-3 justify-content-between mt-3">
                            {getFiliere()}
                        </div>
                        {handleErreur("idFiliere")}
                    </div>
                </Col>
                <Col sm="6">
                    {values.idFiliere != 20 && (
                        <Formation
                            values={values}
                            formations={filieres?.find(f => f.id == values.idFiliere)?.formations}
                            handleChange={handleChange}
                            handleErreur={handleErreur}
                        />
                    )}
                </Col>
            </Row>
            <Row className="mb-3">
                <Col sm="6">
                    <div className="d-flex flex-column">
                        <label className="mb-2">Quel type de modalité envisagez-vous ?* </label>
                        {CodeTypeJourneeInformation == 1 || values.idFormation == 1400990 /*Bac+5 Dev*/ || values.idFormation == 521 /*Bac+5 Res*/ ? (
                            // Affiche la zone de texte si CodeTypeJourneeInformation est 1 ou s la formation choisie est Bac+5 Dev ou Bac+5 Res
                            <input
                                type="text"
                                value="Alternance"
                                readOnly
                                id="idTypeFormation"
                                class="opacity-50"
                            />
                        ) : (
                            // Sinon, affiche le select avec les options
                            <select
                                disabled={CodeTypeJourneeInformation == 1}
                                type="text"
                                value={values.idTypeFormation}
                                onChange={handleChange('idTypeFormation')}
                                id="idTypeFormation"
                            >
                                <option value="0" selected="selected"></option>
                                {getTypeFormation()}
                            </select>
                        )}
                        {handleErreur("idTypeFormation")}
                    </div>
                </Col>
                <Col sm="6">
                    <DateTest
                        values={values}
                        dates={dates}
                        handleChange={handleChange}
                        handleErreur={handleErreur}
                    />
                </Col>
            </Row>
            <div class="mb-5 d-flex justify-content-end mt-sm-0 mt-4 pt-4">
                <button class="btn-gradient-eni" onClick={Continue}>Suivant</button>
            </div>
            <span class="color-grey-light-eni fs-12">* Les champs précédés d'un astérisque sont obligatoires</span>
        </div>
    )
}

export default Journee